/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Library_Gamealt1Inputs */

const id_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game`)
};

const ms_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan`)
};

const da_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spil`)
};

const de_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiel`)
};

const en_us2_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game`)
};

const es_es2_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juego`)
};

const es_mx2_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juego`)
};

const fil_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laro`)
};

const fr_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeu`)
};

const it_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gioco`)
};

const hu_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játék`)
};

const nl_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game`)
};

const no_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spill`)
};

const pl_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gra`)
};

const pt_br2_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogo`)
};

const pt_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogo`)
};

const ro_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joc`)
};

const fi_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peli`)
};

const sv_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spel`)
};

const vi_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game`)
};

const tr_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyun`)
};

const cs_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hra`)
};

const bg_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игра`)
};

const ru_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игра`)
};

const uk_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гра`)
};

const ar_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لعبة`)
};

const hi_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गेम`)
};

const th_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกม`)
};

const ja_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲーム`)
};

const zh_cn2_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`游戏`)
};

const zh_hant1_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遊戲`)
};

const ko_profile_library_gamealt1 = /** @type {(inputs: Profile_Library_Gamealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임`)
};

/**
* | output |
* | --- |
* | "Game" |
*
* @param {Profile_Library_Gamealt1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_library_gamealt1 = /** @type {((inputs?: Profile_Library_Gamealt1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Library_Gamealt1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_library_gamealt1(inputs)
	if (locale === "ms") return ms_profile_library_gamealt1(inputs)
	if (locale === "da") return da_profile_library_gamealt1(inputs)
	if (locale === "de") return de_profile_library_gamealt1(inputs)
	if (locale === "en-US") return en_us2_profile_library_gamealt1(inputs)
	if (locale === "es-ES") return es_es2_profile_library_gamealt1(inputs)
	if (locale === "es-MX") return es_mx2_profile_library_gamealt1(inputs)
	if (locale === "fil") return fil_profile_library_gamealt1(inputs)
	if (locale === "fr") return fr_profile_library_gamealt1(inputs)
	if (locale === "it") return it_profile_library_gamealt1(inputs)
	if (locale === "hu") return hu_profile_library_gamealt1(inputs)
	if (locale === "nl") return nl_profile_library_gamealt1(inputs)
	if (locale === "no") return no_profile_library_gamealt1(inputs)
	if (locale === "pl") return pl_profile_library_gamealt1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_library_gamealt1(inputs)
	if (locale === "pt") return pt_profile_library_gamealt1(inputs)
	if (locale === "ro") return ro_profile_library_gamealt1(inputs)
	if (locale === "fi") return fi_profile_library_gamealt1(inputs)
	if (locale === "sv") return sv_profile_library_gamealt1(inputs)
	if (locale === "vi") return vi_profile_library_gamealt1(inputs)
	if (locale === "tr") return tr_profile_library_gamealt1(inputs)
	if (locale === "cs") return cs_profile_library_gamealt1(inputs)
	if (locale === "bg") return bg_profile_library_gamealt1(inputs)
	if (locale === "ru") return ru_profile_library_gamealt1(inputs)
	if (locale === "uk") return uk_profile_library_gamealt1(inputs)
	if (locale === "ar") return ar_profile_library_gamealt1(inputs)
	if (locale === "hi") return hi_profile_library_gamealt1(inputs)
	if (locale === "th") return th_profile_library_gamealt1(inputs)
	if (locale === "ja") return ja_profile_library_gamealt1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_library_gamealt1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_library_gamealt1(inputs)
	return ko_profile_library_gamealt1(inputs)
});
export { profile_library_gamealt1 as "profile.library.gameAlt" }